import { Link } from 'react-router';
import { Badge, humanize } from '../../../ui/Badge';
import { Card } from '../../../ui/misc';
import { PR_TONE } from '../../tickets/CodeCard';
import type { MergeGate } from '../types';

const external = { target: '_blank', rel: 'noopener noreferrer nofollow' } as const;
export function MergeGateCard({ gate, projectKey }: { gate: MergeGate; projectKey: string }) {
  return (
    <Card
      title="Merge gate"
      subtitle={
        gate.ready
          ? `Every pull request is merged into ${gate.defaultBranch}.`
          : `Merge each ticket's pull request into ${gate.defaultBranch ?? 'the default branch'} to proceed.`
      }
    >
      <div className="table-wrap">
        <table className="table">
          <thead>
            <tr>
              <th>Ticket</th>
              <th>Pull requests</th>
            </tr>
          </thead>
          <tbody>
            {gate.tickets.map((t) => (
              <tr key={t.ticketId}>
                <td>
                  <Link to={`/projects/${projectKey}/tickets/${t.key.split('-').pop()}`} className="mono">
                    {t.key}
                  </Link>
                  {t.branch && <div className="mono small muted">{t.branch}</div>}
                </td>
                <td>
                  {t.pulls.length === 0 ? (
                    <span className="small muted">{t.branch ? 'No pull request yet' : 'No branch'}</span>
                  ) : (
                    <span className="row">
                      {t.pulls.map((p) => (
                        <a key={p.number} href={p.url} {...external} className="row nowrap small">
                          #{p.number} <Badge tone={PR_TONE[p.state]}>{humanize(p.state)}</Badge>
                        </a>
                      ))}
                    </span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {gate.problems.length > 0 && (
        <ul className="small">
          {gate.problems.map((p, i) => (
            <li key={i}>{p.message}</li>
          ))}
        </ul>
      )}
    </Card>
  );
}
